import type { AllRouteEndpoints } from "../routeTypes";

export const alloysProviderAgenticAppGroupId = "/alloys/:provider/agentic/:app_group_id";

export const alloysAmazonBedrockAgenticExternalId = "/alloys/amazon-bedrock/agentic/:app_group_id/external_id";

export const deleteAlloysProviderAgenticAppGroupIdCacheKeys: AllRouteEndpoints[] = [
  alloysProviderAgenticAppGroupId,
];

export const postAlloysProviderAgenticAppGroupIdCacheKeys: AllRouteEndpoints[] = [alloysProviderAgenticAppGroupId];
